<template>
  <div class="container">
    <div class="tradtrends">
      <div class="page-navbar">
        <div class="navbar-header">
          <mt-navbar class="page-part" v-model="selected1">
            <mt-tab-item
              v-for="(item, index) in butList1"
              :key="item.id"
              :id="item.id"
            >
              <div @click="changeSearchType(item.id)">{{ item.name }}</div>
            </mt-tab-item>
          </mt-navbar>
          <mt-navbar class="page-part" v-model="selected2">
            <mt-tab-item
              v-for="(item, index) in butList2"
              :key="index"
              :id="index"
            >
              <div @click="changeSearchDate(index)">{{ item }}</div>
            </mt-tab-item>
          </mt-navbar>
        </div>
      </div>
      <!-- <mt-spinner v-show="loading" type="snake" color="#00ccff" :size="20"></mt-spinner> -->
      <div
        id="main"
        style="width: 100%; height: 300px; padding: 0 10px"
        v-show="noContent"
      ></div>
      <div class="noContent" v-if="!noContent">暂无数据</div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { Toast } from "mint-ui";
import tradTrendsApi from "@/api/api-tradTrends";
import commonFun from "@/libs/commonFun";
import { Indicator } from "mint-ui";
export default {
  name: "tradTrends",
  data() {
    return {
      loading: true,
      msg: "交易趋势",
      selected1: 0,
      butList1: [
        { id: 0, name: "营业额" },
        { id: 1, name: "交易笔数" },
        { id: 2, name: "优惠额" },
        // { id: 3, name: "充值" },
        { id: 4, name: "毛利" },
      ],
      selected2: 0,
      butList2: ["按日", "按周", "按月"],
      dataType: 0, // 0营业额 1交易笔数 2优惠 3充值 4毛利,
      dateType: 0, // 查询周期
      deptId: "",
      noContent: true,
      isAllDept: true,
      dataItems: [],
    };
  },
  methods: {
    init() {
      this.deptId = this.$route.query.deptId || "";
      let deptName = this.$route.query.deptName || "";
      this.isAllDept = this.$route.query.isAllDept || "";
      this.dataItems = this.$route.query.dataItems || "";
      document.title = deptName ? deptName + "-交易趋势" : "交易趋势";
      this.getDaysTrends(this.getData());
    },
    // 按日日期格式化
    getFormattedDate(data) {
      let arr = data.split("-");
      let str = arr[0] + "-" + arr[1];
      return str;
    },
    // 按月日期格式化
    getFormattedMonth(data) {
      let arr = data.split("-");
      let result = null;
      if (arr[1].indexOf(0) == 0) {
        result = arr[1].substr(1);
      } else {
        result = arr[1];
      }
      let str = result + "月";
      return str;
    },
    getData() {
      let data = {
        deptId: this.deptId,
        dataType: this.dataType,
      };
      if (this.deptId != "" && this.deptId != null) {
        data["IsAllDept"] = false;
        data["deptIds"] = new Array(this.deptId);
      } else {
        if (this.isAllDept == true) {
          data["IsAllDept"] = true;
        } else {
          data["deptIds"] = this.dataItems.length > 0 ? this.dataItems : null;
          data["IsAllDept"] = false;
        }
      }
      return data;
    },
    // 交易趋势（按天）
    getDaysTrends(data) {
      this.loading = true;
      tradTrendsApi.getDaysTrends(data).then(
        (res) => {
          if (res && res.length > 0) {
            this.noContent = true;
          } else {
            this.noContent = false;
          }
          let xAxisData = [];
          let yAxisData = [];
          res.map((item) => {
            xAxisData.unshift(this.getFormattedDate(item.salesDate));
            yAxisData.unshift(item.data);
          });
          this.dateType = 0;
          this.getImage(xAxisData, yAxisData, this.dataType, this.dateType);
          this.loading = false;
        },
        (err) => {
          Toast("获取交易趋势失败！");
          this.loading = false;
        }
      );
    },
    // 交易趋势（按周）
    getWeeksTrends(data) {
      this.loading = true;
      //debugger;
      tradTrendsApi.getWeeksTrends(data).then(
        (res) => {
          if (res && res.length > 0) {
            this.noContent = true;
          } else {
            this.noContent = false;
          }
          let xAxisData = [];
          let yAxisData = [];
          res.map((item) => {
            xAxisData.unshift(item.salesDate);
            yAxisData.unshift(item.data);
          });
          this.dateType = 1;
          this.getImage(xAxisData, yAxisData, this.dataType, this.dateType);
          this.loading = false;
        },
        (err) => {
          Toast("获取交易趋势失败！");
          this.loading = false;
        }
      );
    },
    // 交易趋势（按月）
    getMonthsTrends(data) {
      this.loading = true;
      tradTrendsApi.getMonthsTrends(data).then(
        (res) => {
          if (res && res.length > 0) {
            this.noContent = true;
          } else {
            this.noContent = false;
          }
          let xAxisData = [];
          let yAxisData = [];
          res.map((item) => {
            xAxisData.unshift(this.getFormattedMonth(item.salesDate));
            yAxisData.unshift(item.data);
          });
          this.dateType = 2;
          this.getImage(xAxisData, yAxisData, this.dataType, this.dateType);
          this.loading = false;
        },
        (err) => {
          Toast("获取交易趋势失败！");
          this.loading = false;
        }
      );
    },
    getImage(xAxisData, yAxisData, dataType, dateType) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("main"));
      debugger;
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          textStyle: {
            align: "center",
          },
          formatter: function (value) {
            let arr = value[0].name.split("-");
            // 0营业额 1交易笔数 2优惠 3充值 4毛利,
            let type = dataType == 1 ? "笔数" : "金额";
            let unit = dataType == 1 ? "笔" : "元";
            let num =
              dataType == 1
                ? value[0].value
                : commonFun.getNumberFormatter(value[0].value + "");
            let str =
              dateType == 0
                ? arr[0] + "月" + arr[1] + "日" + type
                : dateType == 1
                ? value[0].name
                : value[0].name;
            return str + "<br/>" + num + unit;
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#8d8d8f",
            },
          },
          axisTick: {
            inside: true,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#8d8d8f",
            },
          },
          splitLine: {
            // 改变轴线颜色
            lineStyle: {
              color: "#f2f2f2",
            },
          },
          // 隐藏坐标轴
          axisLine: {
            show: false,
          },
          // 去除坐标轴上的刻度线
          axisTick: {
            show: false,
          },
        },
        grid: {
          left: 50, // 调整这个属性
        },
        series: [
          {
            data: yAxisData,
            type: "line",
            itemStyle: {
              normal: {
                color: "#c59843",
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#c59843",
                  },
                  {
                    offset: 1,
                    color: "#ffe",
                  },
                ]),
              },
            },
          },
        ],
      });
    },
    // 切换查询类型
    changeSearchType(id) {
      this.dataType = id; // 查询类型
      let dateType = this.dateType;
      if (dateType == 0) {
        this.getDaysTrends(this.getData());
      } else if (dateType == 1) {
        this.getWeeksTrends(this.getData());
      } else {
        this.getMonthsTrends(this.getData());
      }
    },
    // 切换查询周期
    changeSearchDate(index) {
      if (index == 0) {
        this.getDaysTrends(this.getData());
      } else if (index == 1) {
        this.getWeeksTrends(this.getData());
      } else {
        this.getMonthsTrends(this.getData());
      }
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    loading(val) {
      if (!val) {
        Indicator.close();
      } else {
        // Indicator.open();
        Indicator.open({
          text: "数据加载中",
          spinnerType: "fading-circle",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fafafa;
  padding: 30px 10px 0 10px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
  .tradtrends {
    background-color: #fff;
    border-radius: 8px;
    // padding-top: 10px;
    .page-navbar {
      .navbar-header {
        .mint-navbar.page-part {
          margin-bottom: 2px;
          height: 40px;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          .mint-tab-item {
            color: #969696;
            padding: 0;
            .mint-tab-item-label div {
              font-size: 14px;
              padding: 17px 0;
            }
          }
          .mint-tab-item.is-selected {
            border-bottom: 2px solid #c59843;
            color: #c59843;
            margin-bottom: -2px;
          }
        }
      }
    }
    .noContent {
      font-size: 12px;
      text-align: center;
      padding: 20px;
    }
  }
}
.mint-indicator-wrapper {
  top: 35%;
  .mint-indicator-text {
    font-size: 12px;
  }
}
.mint-indicator-mask {
  z-index: 999;
}
</style>




// WEBPACK FOOTER //
// src/view/shopSales/tradTrends.vue